import React from "react";
import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Divider
} from "@mui/material";

const border = "1px solid #dcdcdc";
const label = { fontWeight: 600 };
const sectionHeader = {
  backgroundColor: "#f3f6f9",
  fontWeight: 700
};

export const AttendanceSheet = ({ data }) => {
  if (!data || !data.attendanceList || data.attendanceList.length === 0)
    return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Card elevation={3}>
        {/* HEADER */}
        <Box
          sx={{
            background:
              "linear-gradient(135deg, #232526 0%, #414345 100%)",
            color: "#fff",
            py: 2,
            textAlign: "center"
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            ATTENDANCE SHEET (OPENING / CLOSING MEETING)
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table size="small">
            <TableBody>
              {/* CAB NAME */}
              {data.cabName && (
                <TableRow sx={sectionHeader}>
                  <TableCell colSpan={4} sx={border}>
                    CAB Details
                  </TableCell>
                </TableRow>
              )}

              {data.cabName && (
                <TableRow>
                  <TableCell colSpan={4} sx={{ border, ...label }}>
                    CAB Name
                    <Typography variant="body2">
                      {data.cabName}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}

              {/* MEETING TIMINGS */}
              <TableRow sx={sectionHeader}>
                <TableCell colSpan={4} sx={border}>
                  Meeting Schedule
                </TableCell>
              </TableRow>

              <TableRow>
                {data.openingDate && (
                <TableCell colSpan={2} sx={{ border, ...label }}>
                  Opening Meeting Date
                  <Typography variant="body2">
                    {data.openingDate}
                  </Typography>
                </TableCell>
                )}
                {data.openingTime && (
                <TableCell colSpan={2} sx={{ border, ...label }}>
                  Opening Meeting Time
                  <Typography variant="body2">
                    {data.openingTime}
                  </Typography>
                </TableCell>
                )}
              </TableRow>

              <TableRow>
                {data.closingDate && (
                <TableCell colSpan={2} sx={{ border, ...label }}>
                  Closing Meeting Date
                  <Typography variant="body2">
                    {data.closingDate}
                  </Typography>
                </TableCell>
                )}
                {data.closingTime && (
                <TableCell colSpan={2} sx={{ border, ...label }}>
                  Closing Meeting Time
                  <Typography variant="body2">
                    {data.closingTime}
                  </Typography>
                </TableCell>
                )}
              </TableRow>

              {/* ATTENDANCE TABLE HEADER */}
              <TableRow sx={sectionHeader}>
                <TableCell sx={border} align="center" width="8%">
                  SL.
                </TableCell>
                <TableCell sx={border} align="center">
                  Meeting Type
                </TableCell>
                <TableCell sx={border}>
                  Assessors / Lab Personnel Present
                </TableCell>
                <TableCell sx={border}>
                  Capacity / Designation
                </TableCell>
              </TableRow>

              {/* ATTENDANCE ROWS */}
              {data.attendanceList.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor:
                      index % 2 === 0 ? "#fafafa" : "#ffffff"
                  }}
                >
                  <TableCell sx={border} align="center">
                    {index + 1}
                  </TableCell>
                  <TableCell sx={border} align="center">
                    {item.meeting}
                  </TableCell>
                  <TableCell sx={border}>
                    {item.labpersonal}
                  </TableCell>
                  <TableCell sx={border}>
                    {item.designation}
                  </TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell colSpan={4} sx={{ p: 0 }}>
                  <Divider sx={{ my: 2 }} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
};

export default AttendanceSheet;
